export const articlesAnalysis = [
  {
    slug: 'forex-technical-analysis',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'การวิเคราะห์ทางเทคนิค Forex คืออะไร เริ่มอ่านกราฟอย่างไร',
    description:
      'ทำความรู้จักการวิเคราะห์ทางเทคนิค Forex ทั้ง Price Action อินดิเคเตอร์ และแนวรับแนวต้าน พร้อมวิธีเริ่มอ่านกราฟ',
    readingTime: '9 นาที',
    updatedDate: '2026-09-19',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20technical%20analysis%20concept%20teal%20candlestick%20chart%20with%20warm%20orange%20trend%20lines%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-technical-analysis-01&orientation=landscape',
    tags: ['Technical Analysis', 'อ่านกราฟ', 'วิเคราะห์'],
    intro: [
      'การวิเคราะห์ทางเทคนิคคือการศึกษาโครงสร้างราคาในอดีตเพื่อคาดการณ์ทิศทางในอนาคต มันเป็นเครื่องมือช่วยตัดสินใจ ไม่ใช่คำตอบที่การันตีผลลัพธ์',
      'บทความนี้จะปูพื้นฐานการอ่านกราฟสำหรับมือใหม่',
    ],
    sections: [
      {
        id: 'what',
        heading: 'การวิเคราะห์ทางเทคนิคคืออะไร',
        paragraphs: [
          'เป็นการใช้ข้อมูลราคาและปริมาณการซื้อขายในอดีตมาวิเคราะห์แนวโน้มและจุดที่มีโอกาสเกิดการเปลี่ยนทิศ โดยเชื่อว่าราคาสะท้อนข้อมูลข่าวสารไปแล้ว',
        ],
        bullets: [
          'ใช้กราฟเป็นหลัก',
          'อาศัยรูปแบบที่เกิดซ้ำและสถิติ',
          'ใช้ร่วมกับกรอบเวลาหลายระดับ',
        ],
        steps: [],
      },
      {
        id: 'three-tools',
        heading: 'เครื่องมือวิเคราะห์ 3 กลุ่มหลัก',
        paragraphs: [
          'เทรดเดอร์ส่วนใหญ่ผสมผสานเครื่องมือสามกลุ่มนี้เข้าด้วยกัน เพื่อยืนยันสัญญาณก่อนตัดสินใจ',
        ],
        bullets: [
          'Price Action อ่านพฤติกรรมราคาโดยตรง',
          'Technical Indicators เช่น RSI MACD Moving Average',
          'Support & Resistance แนวรับแนวต้านที่ราคามักหยุด',
        ],
        steps: [],
      },
      {
        id: 'timeframe',
        heading: 'เลือกกรอบเวลาอย่างไร',
        paragraphs: [
          'เริ่มจากกรอบเวลาใหญ่เพื่อดูแนวโน้มรวม แล้วค่อยลงมาที่กรอบเวลาเล็กเพื่อหาจุดเข้า การมองหลายกรอบเวลาช่วยลดสัญญาณหลอก',
          'ลำดับที่นิยมใช้คือ D1 สำหรับทิศทางหลัก H4 สำหรับโซนราคา และ M15 สำหรับจังหวะเข้า ถ้า D1 กับ H4 ชี้ทางเดียวกัน อัตราความสำเร็จของ M15 จะสูงขึ้นอย่างชัดเจน เพราะสัญญาณที่สวนแนวโน้มใหญ่บน M15 มักถูกกลบด้วยแรงซื้อขายของกรอบใหญ่ภายในไม่กี่ชั่วโมง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'การวิเคราะห์ทางเทคนิคแม่นยำแค่ไหน',
        a: 'ไม่มีเครื่องมือใดแม่นยำ 100% การวิเคราะห์เป็นเรื่องของความน่าจะเป็น ต้องใช้ร่วมกับการบริหารความเสี่ยงเสมอ',
        a2: 'ตัวเลขที่ควรคิดคือ แม้ระบบที่ชนะ 55% ก็ยังขาดทุนติดกัน 4-5 ครั้งได้ใน 100 ไม้ ถ้าใช้ความเสี่ยง 5% ต่อไม้ การขาดทุนติดกัน 5 ครั้งจะกินทุนไป 22% และต้องทำกำไร 28% เพื่อกลับมาเท่าทุน นี่คือเหตุผลที่ความเสี่ยงต้องเล็กพอจะรับช่วงแย่ได้',
      },
      {
        q: 'มือใหม่ควรเริ่มจากกรอบเวลาไหน',
        a: 'แนะนำกรอบเวลาชั่วโมงและรายวันก่อน เพราะสัญญาณหลอกน้อยกว่ากรอบเวลาเล็กมาก',
        a2: 'ตัวเลขที่ต่างชัดคือ กรอบ M5 ให้สัญญาณราว 20-30 ครั้งต่อวัน แต่มีอัตราการหลอกสูง ส่วน H4 ให้น้อยกว่า 3 ครั้งต่อวันและทิศทางชัดกว่า ถ้าเริ่มจากกรอบนาที คุณจะมีโอกาสตัดสินใจผิดมากกว่าถึง 5-10 เท่าในช่วงเรียนรู้',
      },
    ],
    related: ['price-action', 'technical-indicators', 'support-resistance'],
  },
  {
    slug: 'price-action',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Price Action คืออะไร วิธีอ่านพฤติกรรมราคาแบบไม่พึ่งอินดิเคเตอร์',
    description:
      'เรียนรู้ Price Action และการอ่านแท่งเทียนเพื่อจับจังหวะตลาดจากโครงสร้างราคาโดยตรง',
    readingTime: '8 นาที',
    updatedDate: '2026-09-18',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20price%20action%20candlestick%20patterns%20teal%20and%20soft%20grey%20candles%20warm%20orange%20highlight%20on%20light%20background%20editorial%20flat%20fintech%20no%20text%20no%20people&width=1200&height=675&seq=art-price-action-01&orientation=landscape',
    tags: ['Price Action', 'แท่งเทียน', 'วิเคราะห์'],
    intro: [
      'Price Action คือการอ่านพฤติกรรมราคาจากกราฟโดยตรง ไม่ต้องพึ่งอินดิเคเตอร์ ช่วยให้เห็นภาพรวมของตลาดได้ชัดขึ้น',
      'บทความนี้จะแนะนำหลักการอ่านแท่งเทียนและโครงสร้างตลาดที่มือใหม่ควรรู้',
    ],
    sections: [
      {
        id: 'candles',
        heading: 'อ่านแท่งเทียนให้เป็น',
        paragraphs: [
          'แท่งเทียนแต่ละแท่งบอกราคาเปิด ปิด สูงสุด และต่ำสุดในกรอบเวลาหนึ่ง การอ่านขนาดไส้และตัวแท่งช่วยบอกแรงซื้อแรงขาย',
        ],
        bullets: [
          'ไส้ยาวบ่งบอกการต่อสู้ระหว่างฝั่งซื้อและฝั่งขาย',
          'แท่งเทียนตัวใหญ่แสดงโมเมนตัมที่ชัดเจน',
          'รูปแบบกลับตัวมักเกิดหลังแนวรับแนวต้าน',
        ],
        steps: [],
      },
      {
        id: 'structure',
        heading: 'โครงสร้างตลาด',
        paragraphs: [
          'ตลาดเคลื่อนไหวเป็นแนวโน้มขึ้น แนวโน้มลง หรือไซด์เวย์ การรู้ว่าตอนนี้อยู่ภาวะไหนช่วยให้เลือกกลยุทธ์ได้เหมาะสม',
        ],
        bullets: [
          'แนวโน้มขึ้นคือ Higher High และ Higher Low',
          'แนวโน้มลงคือ Lower High และ Lower Low',
          'ไซด์เวย์มักเกิดในกรอบแคบ',
        ],
        steps: [],
      },
      {
        id: 'practice',
        heading: 'ฝึกอย่างไรให้เก่ง Price Action',
        paragraphs: [
          'ฝึกมองกราฟเปล่าและจดบันทึกจุดที่ราคาเปลี่ยนทิศซ้ำ ๆ ยิ่งฝึกมาก ความคุ้นเคยต่อรูปแบบจะเพิ่มขึ้น',
          'วิธีที่ได้ผลคือย้อนกราฟ EURUSD 100 แท่งบน H4 แล้วทำเครื่องหมาย swing high กับ swing low ทุกจุด จากนั้นเขียนว่าลำดับยกขึ้นหรือกดลง ทำแบบนี้ 20 ครั้งในคู่เงินเดียว จะเริ่มเห็นว่า Price Action ไม่ใช่รูปแบบลึกลับ แต่คือการอ่านว่าแรงไหนเพิ่งชนะในแต่ละช่วง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Price Action ใช้ได้กับทุกตลาดไหม',
        a: 'ใช้ได้กับทุกตลาดที่มีกราฟราคา ไม่จำกัดเฉพาะ Forex เพราะหลักการคือการอ่านพฤติกรรมราคาเหมือนกัน',
        a2: 'ข้อจำกัดที่ต่างกันคือ Forex มีสภาพคล่องสูงและมีแนวโน้มจากข่าวเศรษฐกิจ ส่วนหุ้นมี Gap เปิดตลาดที่ทำให้ Stop Loss ไม่ทำงานตามราคา หลักการอ่านกราฟใช้ร่วมกันได้ แต่การคำนวณความเสี่ยงต้องปรับตามสภาพคล่องของแต่ละตลาด',
      },
      {
        q: 'ต้องเพิ่มอินดิเคเตอร์ไหม',
        a: 'ไม่จำเป็น Price Action ใช้กราฟเปล่าได้ แต่อินดิเคเตอร์ช่วยยืนยันสัญญาณได้ในบางสถานการณ์',
        a2: 'วิธีที่ใช้ได้จริงคือใช้กราฟเปล่าหาโซนและโครงสร้างก่อน แล้วค่อยเปิดอินดิเคเตอร์ 1 ตัวเพื่อดูว่าจังหวะนั้นมีแรงสนับสนุนหรือไม่ ถ้าเพิ่มอินดิเคเตอร์ทั้งที่ยังอ่านโครงสร้างไม่ได้ จะกลายเป็นการวาดเส้นตามใจมากกว่าอ่านราคา',
      },
    ],
    related: ['support-resistance', 'forex-technical-analysis', 'technical-indicators'],
  },
  {
    slug: 'technical-indicators',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Technical Indicators ที่มือใหม่ควรรู้ RSI MACD และ Moving Average',
    description:
      'รู้จักอินดิเคเตอร์ยอดนิยมอย่าง RSI, MACD และ Moving Average พร้อมวิธีอ่านค่าและข้อควรระวัง',
    readingTime: '9 นาที',
    updatedDate: '2026-09-16',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20technical%20indicator%20panels%20teal%20oscillator%20lines%20warm%20orange%20signal%20cross%20on%20light%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-technical-indicators-01&orientation=landscape',
    tags: ['RSI', 'MACD', 'Moving Average'],
    intro: [
      'อินดิเคเตอร์คือเครื่องมือที่คำนวณจากราคาและแสดงผลเป็นเส้นหรือกราฟ ช่วยให้เห็นสัญญาณที่ตาอาจมองไม่ทัน',
      'บทความนี้จะแนะนำอินดิเคเตอร์ 3 ตัวที่มือใหม่ควรรู้จัก',
    ],
    sections: [
      {
        id: 'rsi',
        heading: 'RSI Relative Strength Index',
        paragraphs: [
          'RSI วัดความแรงของโมเมนตัมโดยมีค่าตั้งแต่ 0 ถึง 100 ค่าเกิน 70 มักถือว่าเข้าสู่โซนซื้อมากเกินไป และต่ำกว่า 30 คือขายมากเกินไป',
        ],
        bullets: ['ใช้ดูภาวะซื้อมากเกินไปหรือขายมากเกินไป', 'ระวังสัญญาณหลอกในตลาดแนวโน้มแรง', 'ใช้ร่วมกับแนวรับแนวต้านเสมอ'],
        steps: [],
      },
      {
        id: 'macd',
        heading: 'MACD Moving Average Convergence Divergence',
        paragraphs: [
          'MACD ใช้เส้นค่าเฉลี่ยสองเส้นมาหาความต่าง ช่วยดูโมเมนตัมและการตัดกันของเส้นสัญญาณ',
        ],
        bullets: ['เส้นตัดขึ้นอาจสื่อโมเมนตัมบวก', 'เส้นตัดลงอาจสื่อโมเมนตัมลบ', 'ดูฮิสโตแกรมประกอบเพื่อยืนยัน'],
        steps: [],
      },
      {
        id: 'ma',
        heading: 'Moving Average',
        paragraphs: [
          'Moving Average คือค่าเฉลี่ยราคาในช่วงเวลาหนึ่ง ใช้ดูแนวโน้มและเป็นแนวรับแนวต้านแบบเคลื่อนที่',
        ],
        bullets: ['เส้นค่าเฉลี่ยระยะสั้นไวต่อราคา', 'เส้นค่าเฉลี่ยระยะยาวสะท้อนแนวโน้มใหญ่', 'ใช้ตัดกันเพื่อดูสัญญาณเปลี่ยนแนวโน้ม'],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ยิ่งใช้อินดิเคเตอร์เยอะยิ่งดีไหม',
        a: 'ไม่ใช่ การใช้อินดิเคเตอร์มากเกินไปทำให้สัญญาณขัดแย้งกันเอง แนะนำ 1-2 ตัวที่เข้าใจดีก็เพียงพอ',
        a2: 'ตัวเลขที่ช่วยได้คือ 3 อินดิเคเตอร์ที่วัดเรื่องเดียวกัน เช่น RSI, Stochastic และ MACD มักให้สัญญาณขัดกันใน 4-5 จาก 10 ครั้ง และคุณจะเลือกเชื่อตัวที่ตรงกับความอยาก ผลคือไม่ได้ข้อมูลเพิ่ม แต่ได้ความมั่นใจปลอม',
      },
      {
        q: 'อินดิเคเตอร์ใช้แทนการวิเคราะห์ราคาได้ไหม',
        a: 'ไม่ได้ อินดิเคเตอร์คำนวณจากราคาในอดีต จึงควรใช้ยืนยันร่วมกับการวิเคราะห์โครงสร้างราคา',
        a2: 'เพราะอินดิเคเตอร์ทุกตัวคำนวณจากราคาที่เกิดขึ้นแล้ว จึงตามราคาช้ากว่าตลอด ถ้าตลาดไซด์เวย์นาน 30 แท่งขึ้นไป สัญญาณตัดกันจะล้มเหลวบ่อยจนแทบใช้ไม่ได้ นี่คือช่วงที่ต้องพึ่งโครงสร้างราคาแทน',
      },
    ],
    related: ['forex-technical-analysis', 'price-action', 'support-resistance'],
  },
  {
    slug: 'support-resistance',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'แนวรับแนวต้าน (Support & Resistance) คืออะไร วางแผนเทรดอย่างไร',
    description:
      'เข้าใจแนวรับและแนวต้าน จุดที่ราคามักหยุดหรือกลับตัว พร้อมวิธีนำไปใช้วางแผนเข้าและออกออเดอร์',
    readingTime: '8 นาที',
    updatedDate: '2026-09-15',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20support%20and%20resistance%20levels%20teal%20horizontal%20bands%20with%20warm%20orange%20price%20bounce%20on%20light%20background%20editorial%20flat%20fintech%20no%20text%20no%20people&width=1200&height=675&seq=art-support-resistance-01&orientation=landscape',
    tags: ['แนวรับ', 'แนวต้าน', 'วิเคราะห์'],
    intro: [
      'แนวรับและแนวต้านคือพื้นที่ที่ราคาเคยหยุดหรือกลับตัว ซึ่งมักสะท้อนจุดที่ฝั่งซื้อและฝั่งขายปะทะกัน',
      'บทความนี้จะอธิบายวิธีหาและใช้แนวรับแนวต้านในการวางแผนเทรด',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'แนวรับและแนวต้านคืออะไร',
        paragraphs: [
          'แนวรับคือโซนที่ราคามักหยุดลงเพราะมีแรงซื้อเข้ามา ส่วนแนวต้านคือโซนที่ราคามักหยุดขึ้นเพราะมีแรงขายเข้ามา',
        ],
        bullets: [
          'แนวรับแนวต้านเป็นโซน ไม่ใช่เส้นเดียว',
          'ยิ่งราคาแตะหลายครั้ง ยิ่งมีความสำคัญ',
          'เมื่อแนวรับถูกเบรก อาจกลายเป็นแนวต้าน',
        ],
        steps: [],
      },
      {
        id: 'plan',
        heading: 'นำไปใช้วางแผนเทรดอย่างไร',
        paragraphs: [
          'รอให้ราคาเข้าใกล้แนวรับแนวต้านแล้วดูปฏิกิริยา หากมีสัญญาณยืนยันจึงพิจารณาเข้าเทรด และวาง Stop Loss ไว้หลังโซนนั้น',
        ],
        bullets: [
          'ใช้เป็นจุดตั้ง Take Profit',
          'ใช้กำหนดตำแหน่ง Stop Loss',
          'ใช้เลือกจุดเข้าที่ได้อัตราส่วน Risk Reward ดี',
        ],
        steps: [],
      },
      {
        id: 'common-mistake',
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'การลากแนวรับแนวต้านให้พอดีกับออเดอร์ที่ต้องการ เป็นสิ่งที่ควรหลีกเลี่ยง ให้วาดจากกราฟจริงและยอมรับผลลัพธ์ตามแผน',
          'อีกข้อที่พบบ่อยคือลากเส้นเยอะเกินไปจนทั้งจอเต็มไปด้วยโซน ซึ่งทำให้ไม่เหลือพื้นที่ตัดสินใจ ทางที่ดีควรเหลือโซนที่สำคัญจริงเพียง 2 ถึง 3 โซนต่อกรอบเวลา และถ้าราคาเบรกโซนนั้นชัดเจนด้วยแท่งปิดเกิน 10 ถึง 15 Pip ให้ถือว่าโซนเดิมถูกทำลายและประเมินใหม่',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'แนวรับแนวต้านใช้กับกรอบเวลาไหน',
        a: 'ใช้ได้ทุกกรอบเวลา แต่แนวจากกรอบเวลาใหญ่กว่ามักมีความสำคัญสูงกว่า',
        a2: 'ตัวอย่างที่ชัดคือ แนวต้านบน D1 ที่ถูกแตะ 3 ครั้งมีความหมายมากกว่าแนวต้านบน M15 ที่ถูกแตะ 10 ครั้ง เพราะมีเงินไหลผ่านระดับนั้นมากกว่า วิธีทำงานคือหาโซนจาก D1 หรือ H4 ก่อน แล้วค่อยใช้ M15 หาจุดเข้าภายในโซน',
      },
      {
        q: 'ราคาเบรกแนวแล้วกลับมาได้ไหม',
        a: 'ได้ นี่คือรูปแบบ False Breakout ซึ่งเป็นกับดักที่พบบ่อย ควรมีสัญญาณยืนยันก่อนเข้าเทรด',
        a2: 'สัญญาณที่ช่วยแยกได้คือ ราคาเบรกแล้วปิดกลับเข้าโซนภายใน 1-2 แท่ง ปริมาณการแกว่งลดลง และไม่มีการยืนเหนือระดับเดิม วิธีรับมือที่ได้ผลคือรอแท่งปิดยืนยัน หรือรอราคากลับมาแตะโซนเดิมแล้วจึงเข้าตามทิศที่ยืนยัน',
      },
    ],
    related: ['price-action', 'forex-technical-analysis', 'technical-indicators'],
  },
];